export default "__VITE_ASSET__CfQBl9A7__"